import { cn } from '@heroui/react';
import { useApplicationShell } from '@rhino-project/ui-heroui';
import { NavIcon } from '../../icons';

// Mirrors @rhino-project/ui-heroui's NavItem markup/classes so an
// action-triggering entry (mint-and-open, not a route) sits visually
// consistent with the rest of the sidebar. NavItem itself is a plain router
// Link and has no notion of a non-navigating action.
export type NavActionItemProps = {
  title: string;
  icon: string;
  disabled?: boolean;
  /** Collapse the shell's mobile drawer when the item is clicked. */
  closeMenuOnClick?: boolean;
  onAction: () => void;
};

export const NavActionItem = ({
  title,
  icon,
  disabled,
  closeMenuOnClick = true,
  onAction
}: NavActionItemProps) => {
  const { setMenuOpen } = useApplicationShell();

  return (
    <li>
      <button
        type="button"
        disabled={disabled}
        onClick={() => {
          onAction();
          if (closeMenuOnClick) setMenuOpen(false);
        }}
        className={cn(
          'group block w-full text-left',
          disabled && 'pointer-events-none opacity-50'
        )}
      >
        <div className="flex gap-2 items-center relative py-1.5 px-3 min-h-11 h-[44px] w-full box-border subpixel-antialiased cursor-pointer rounded-lg outline-none data-[focus-visible=true]:z-10 data-[focus-visible=true]:outline-2 data-[focus-visible=true]:outline-focus data-[focus-visible=true]:outline-offset-2 hover:transition-colors hover:bg-accent/10 dark:hover:bg-accent/20">
          {icon && <NavIcon icon={icon} />}
          <span className="flex-1 truncate text-sm font-medium text-foreground/60">
            {title}
          </span>
        </div>
      </button>
    </li>
  );
};
